var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#273943",
    fillRule: "evenodd",
    d: "M6.166 4.166A8.25 8.25 0 0 1 20.25 10c0 3.198-2.074 6.266-4.294 8.61A29.672 29.672 0 0 1 12 22.082a29.677 29.677 0 0 1-3.956-3.473C5.824 16.265 3.75 13.197 3.75 10a8.25 8.25 0 0 1 2.416-5.834Zm5.418 19.458L12 23l-.416.624a.75.75 0 0 0 .832 0L12 23l.416.624h.001l.002-.002.006-.004.022-.015a11.758 11.758 0 0 0 .379-.267 31.173 31.173 0 0 0 4.219-3.696c2.28-2.406 4.705-5.838 4.705-9.64a9.75 9.75 0 1 0-19.5 0c0 3.802 2.426 7.234 4.706 9.64a31.168 31.168 0 0 0 4.218 3.697 18.242 18.242 0 0 0 .379.266l.022.015.006.004.002.001ZM9.75 10a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0ZM12 6.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgPin;